export function extractHost(data: string) {
  try {
    const url = new URL(data)

    return url.host.replace(/^(www\.)/, '')
  } catch (e: any) {
    return data
  }
}
